<template>
  <div :class="['router-wraper', {'no-wraper-rtl': noRTLWraperPage}, {'fleet-register-pc': isFleetPCNew}, {'router-wraper-mask': _dialog_close}]">
    <router-view></router-view>
    <help-icon v-if="isShowHelp"></help-icon>
    <cookie-pop ref="cookiepop" v-if="isShowCookie"></cookie-pop>
    <div v-if="_dialog_close" class="bg-mask"></div>
    <close-dialog v-if="_dialog_close" />
  </div>
</template>
<script>
import {  mapState, mapMutations } from "vuex";
import HelpIcon from './components/base/help-icon'
import CookiePop from './components/base/cookie-pop.vue'
import CloseDialog from './components/base/close-dialog.vue'
// import { ends } from './tools/constant'
import { computeJumpTime, getEnd } from './tools/utils'


export default {
  name: "App",
  components: { HelpIcon, CookiePop, CloseDialog },
  data() {
    return {};
  },
  computed: {
    ...mapState(["_help_icon", "_page_stay_time", "_page_jump_time", "_route_path", "_dialog_close", "_uuid"]),
    // inApp() {
    //   return !!Fusion.pickImage
    // },
    params() {
      return new URLSearchParams(location.search);
    },
    isPreviewPage() {
      return this.params.get('ob_page_type') === 'preview';
    },
    noRTLWraperPage() {
      // let up = new URLSearchParams(location.search)
      let lang = this.params.get('lang')
      let name = this.$route.name;
      return (/^photoInfo/.test(name) || /^baseInfo/.test(name) || /loginMxComp/.test(name) || /avatarNew/.test(name)) && lang === 'ar-EG';
    },
    isFleetPCNew() {
      // let up = new URLSearchParams(location.search)
      let fleet_register_pc = this.params.get('fleet_register_pc')
      return fleet_register_pc == 1
    },
    isShowHelp() {
      let up = new URLSearchParams(location.search)
      let country = up.get('location_country')
      let name = this.$route.name;
      let isShowHelp = false;
      // @20201216下掉墨西哥help
      // if (country === 'BR') {
      //   // 登录页都展示help入口
      //   if (/^login/.test(name)){
      //     isShowHelp = true;
      //   } else {
      //     // passport之后的页面是否展示help交由实验控制
      //     isShowHelp = this._help_icon;
      //   }
      // }
      // iOS墨西哥司机端内不上help入口
      // if (country === 'MX' && ends.inApp && !ends.isAndroid){
      //   isShowHelp = false
      // }

      // @20210518 手机号页的help展示也使用实验接口(不传ticket)
      isShowHelp = this._help_icon;
      // @20211117 新 司机注册落地页 不展示
      if (name === 'newLandingPage') {
        isShowHelp = false;
      }

      return isShowHelp
    },
    isShowCookie() {
      // let up = new URLSearchParams(location.search)
      let country = this.params.get('location_country')
      // 巴西物料没有准备好，所以先不上巴西
      // return !['BR', 'MX'].includes(country)

      // 本次修改 除了AU、NZ、EG之外都不弹
      return ['AU', 'NZ', 'EG'].includes(country)
    },
  },
  methods: {
    ...mapMutations(["setState"]),
  },
  created() {
    // @20231110 离线包打包
    // 重新打包
    let up = new URLSearchParams(location.search)
    if (up.get('ob_page_type') != 'preview') {
      this.$router.replace({ name: "home" });
    }

  },
  watch:{
    _dialog_close(newV, oldVal) {
      if(this._dialog_close === true) {
        try{
            Omega.trackEvent("ibt_appbar_back_toast_sw", "", {
            channel: this.params.get("channel") || "",
            oid: this.params.get("oid") || Omega.getOmgid(),
            end: getEnd(),
            location_country_code: this.params.get("location_country"),
            driver_id: this.params.get("uid") || this._uuid + ""
          });
        } catch(e) {

        }
       
      }
    }
  },
  mounted() {
    // 进入二级页面点击叉号按钮展示关闭或取消弹窗
    Fusion.interceptCloseButton && Fusion.interceptCloseButton({
      jsCallback: '_PAGE_CLOSE_BUTTON'
    }, () => {});
    window._PAGE_CLOSE_BUTTON = () => {
      this.setState({
        _dialog_close: true,
      });
      if (this._dialog_close) {
        Fusion && Fusion.resetBack && Fusion.resetBack({
          reset: 0,
          jsCallback: '_PAGE_GO_CLOSE_BACK'
        });
        window._PAGE_GO_CLOSE_BACK = () => {};
      }
    };
    try {
      computeJumpTime(this)
    } catch (error) {}
    // cookie授权弹窗show
    try {
      const cookie_set = localStorage.getItem('hasSelectedCookieSet');
      if (!this.isPreviewPage) {
        if (!Fusion.pickImage) {
          //未设置过
          if (!cookie_set) {
            if (this.$refs.cookiepop && this.isShowCookie) {
                // 当前国家有cookie弹窗
                this.$refs.cookiepop.popShow = true;
            } else {
              // 当前国家没有cookie弹窗
              window.track();
            }
          } else if(cookie_set === '1'){
            //已选择过
            window.track();
          }
        } else {
          if (window.track) {
            window.track();
            window.trackReady = true
          }
        }
      }
    }
    catch (e) {
      console.log('track error', e)
    }
  }
};
</script>
<style lang='scss'>
.router-wraper {
  height: 100%;
  max-width: 450px;
  margin: auto;
  &.fleet-register-pc {
    width: 720px;
    max-width: 720px;
    padding-top: 20px;
    box-sizing: border-box;
  }
}
.bg-mask {
  position: fixed;
  z-index: 998;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(15,25,40, 0.6);
}
.router-wraper-mask {
  overflow: hidden;
}
</style>
<style lang='scss'>
@import './css/fonts.scss';
@import './css/common.scss';
@import './css/ar-eg.scss';
</style>



